import * as lenis from './lenis'

export function init() {
	setTimeout(() => {
	  const header = document.querySelector('header');
	  document.body.style.setProperty('--header-height-marquee', `${header.offsetHeight}px`);
	  lenis.resize();
	}, 100)
}